<template>
  <div class="biddingmonitoring">
    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-center">
          <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ detail.biddingStatusName }}</div>
          <Countdown v-if="nowTime && detail.biddingStatusDate && wsUrl" :now-time="nowTime" :detail="detail" :ws-url="wsUrl" @time-down="timeDown" @websocket="wsFefresh" />
        </div>
        <div>
          <el-button @click="$router.back()">{{ $t('bidmanagementpur.biddingmonitoring.back') }}</el-button>
          <el-button type="danger" :disabled="!canBidSign" @click="giveUp">{{ $t('bidmanagementsup.biddinghall.giveUp') }}</el-button>
          <el-button type="success" :disabled="!canBidSign" @click="submit">{{ $t('bidmanagementsup.biddinghall.submit') }}</el-button>
        </div>
      </div>
      <div class="biddingmonitoring-notice">
        <img src="~@/assets/images/notice.png">
        <span>{{ detail.message }}</span>
      </div>
    </div>

    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementsup.biddinghall.whiteForm') }}</div>
      </div>
      <div><component :is="table.tpl()" :[tableProp]="table" :list="goodsList" style="padding: 10px 0 0" /></div>
    </div>

    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ detail.biddingName }}</div>
        <div class="biddingmonitoring-more" @click="showMore = true">更多详情</div>
      </div>
      <div><HeaderInfo :data="detail" /></div>
    </div>

    <div>
      <div class="biddingmonitoring-header biddingmonitoring-white">
        <div class="biddingmonitoring-center">
          <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementpur.biddingmonitoring.biddingrecord') }}</div>
          <div class="biddingmonitoring-round-tab">{{ $t('bidmanagementpur.biddingmonitoring.currentRound', [detail.currentRound]) }}</div>
        </div>
        <div class="biddingmonitoring-buttons">
          <div class="biddingmonitoring-button" @click="changeShowHide">
            <i class="iconfont icon-zhankaiquanbu" style="font-size: 14px;" />
            {{ closedAll ? $t('bidmanagementpur.biddingmonitoring.showAll') : $t('bidmanagementpur.biddingmonitoring.hideAll') }}
          </div>
        </div>
      </div>
      <div v-loading="loading">
        <TableList v-if="detail.currentRound !== undefined" :data="detail" :list="list" no-btns @search="searchList" />
      </div>
    </div>
    <el-drawer
      :visible.sync="showMore"
      direction="rtl"
      size="75%"
      destroy-on-close
      :with-header="false"
    >
      <Detail :data="detail" />
    </el-drawer>
  </div>
</template>

<script>
import http from '@/plugin/axios'
import Countdown from '@/views/purchaser/bidmanagementpur/mybidding/biddingmonitoring/components/countdown'
import HeaderInfo from '@/views/purchaser/bidmanagementpur/mybidding/biddingmonitoring/components/header-info'
import TableList from '@/views/purchaser/bidmanagementpur/mybidding/biddingmonitoring/components/table-list'
// import Dialog from '@utils/common/dialog'
import emitter from 'element-ui/src/mixins/emitter'
// import Form from '@utils/form'
import Detail from '@/views/purchaser/bidmanagementpur/mybidding/detail/detail'
import Table from '@utils/table'
import OptionsSelect from '@/components/select/options-select/options-select.vue'
import Options from '@utils/common/options/index'
import SearchSelectForm from '@/components/select/search-select-form/search-select-form.vue'
import Select from '@utils/common/select'
import UploadFile from './components/upload-file'
import PreviewFile from '@/components/select/upload-select/preview-file'

function parseFile(files = []) {
  return files.map(item => {
    return {
      name: item.fileName,
      url: '/srmFile/getFile',
      baseURL: process.env.VUE_APP_BASE_API,
      fileId: item.fileId,
      data: { fileId: `${item.fileId}` }
    }
  })
}

function autoGetTaxRate(data, options) {
  if (data && data.row && !data.row.taxRate && options && options[0]) {
    data.row.taxRate = options[0].taxTypeNo
  }
}

export default {
  components: {
    Countdown,
    HeaderInfo,
    TableList,
    Detail
  },
  mixins: [emitter],
  data() {
    return {
      nowTime: null,
      detail: {},
      list: [],
      loading: false,
      showMore: false
    }
  },
  computed: {
    closedAll() {
      if (!this.list.length) return false
      const list = this.list.filter(i => i.show)
      return !list.length
    },
    canBidSign() {
      return this.detail.canBidSign === 'Y'
    },
    goodsList() {
      return this.detail.goodsList || []
    },
    table() {
      return new Table('bidmanagementsup.biddinghall')
        .edit(this.canBidSign)
        // .edit(true)
        .type('index')
        .add('goodsType')
        .add('number')
        .add('name')
        .add('expirationDate')
        .add('model')
        .add('qty')
        .add('unit')
        .add('currencyNo')
        .add('category')
        .add('technologyName')
        .add('fixedPrice')
        .add('giveUpSign').editor({ component: OptionsSelect, _options: Options.use('yesNo') }).op('yesNo')
        .add('goodsPrice').editor({ component: 'el-input-number', controlsPosition: 'right', min: 0 })
        .add('taxRate').editor({ component: SearchSelectForm, _select: Select.use('/srmTaxExchangeRate/getTaxExchangeRatePage') }).on('created-options', autoGetTaxRate)
        .add('taxIncludedAmount')
        .add('remarks').editor()
        .add('purchaseStandard')
        .add('expectedDeliveryDate')
        .add('goodsFileList').editor({ component: UploadFile }).component(PreviewFile).bind('parse', parseFile)
    },
    tableProp() {
      return '$table'
    }
  },
  async created() {
    this.nowTime = await http({
      url: '/getServerDate',
      baseURL: process.env.VUE_APP_BASE_API,
      data: {},
      loading: true
    })

    this.detail = await http({
      url: '/srmBiddingHead/getBiddingMonitorDetail',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { id: this.$route.params.id },
      loading: true
    })

    this.wsUrl = `${process.env.VUE_APP_PURCHASE_WM}/bidWebSocket/${this.$route.params.id}/${new Date(this.nowTime).getTime()}`
  },
  methods: {
    timeDown() {
      this.dispatch('Layout', 'layout.refresh', [this])
    },
    // websorket通知更新
    async wsFefresh(message) {
      this.detail.message = message
    },
    changeShowHide() {
      const changed = this.closedAll
      this.list.forEach(item => {
        item.show = changed
      })
    },
    async searchList(data) {
      this.loading = true
      http({
        url: '/srmBiddingHead/getOnceBiddingRecord',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: data
      }).then(list => {
        this.list = list.map(item => ({ ...item, show: true }))
      }).finally(() => {
        this.loading = false
      })
    },
    async giveUp() {
      await this.$confirm('一旦放弃报价，相当于放弃本次竞价，确认操作吗？')
    },
    async submit() {
      await http({
        url: '/srmBiddingHead/commitBidding',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: {
          id: this.$route.params.id,
          goodsList: this.goodsList,
          currentRound: this.detail.currentRound
        }
      })
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.biddingmonitoring {
  &-box {
    position: relative;
    padding: 12px;
    background: #fff;
    margin-bottom: 12px;
  }
  &-white {
    padding: 12px;
    background: #fff;
  }

  &-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  &-center {
    display: inline-flex;
    align-items: center;
  }

  &-title {
    display: inline-flex;
    align-items: center;
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
  }

  &-notice {
    font-size: 12px;
    color: #333;
    height: 36px;
    line-height: 36px;
    background-color: #F7F7F7;
    padding: 0 10px;
    margin-top: 20px;
    & > img {
      width: 42px;
      vertical-align: -3px;
      margin-right: 10px;
    }
  }

  &-more {
    font-size: 13px;
    color: #008ee3;
    height: 36px;
    line-height: 36px;
    background-color: #E1F4FF;
    position: absolute;
    padding: 0 18px;
    top: 12px;
    right: 0px;
    cursor: pointer;
    &::before {
      content: '';
      width: 20px;
      height: 36px;
      background-color: #E1F4FF;
      position: absolute;
      transform: skew(-20deg);
      left: -8px;
      border-radius: 4px;
    }
  }

  &-round-tab {
    margin-left: 15px;
    background-color: #E7F6FF;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    color: #008ee3;
    font-size: 12px;
  }

  &-button {
    display: inline-block;
    font-size: 12px;
    margin-left: 22px;
    cursor: pointer;
  }
}
</style>
